var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-row',{attrs:{"data-test":"readonly-requirements","align":"center"}},[_c('v-col',{staticClass:"shrink pr-2"},[_c('v-icon',[_vm._v("navigation")])],1),_c('v-col',{staticClass:"grow"},[_c('vs-text',[_vm._v(_vm._s(_setup.resourceType)+" — Not assigned yet ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }